import React from 'react';

import { DocsListContainer } from './styles';

export const DocsList = (props) => {
    return <DocsListContainer>{props.children}</DocsListContainer>;
};
